import { jobOfferApi } from "@/services/api"
import { ref } from "vue"

// `status` is forwarded to the API ('active' by default there, 'all' to include expired offers);
// `order: 'activeFirst'` lists the running offers before the expired ones
export const useInfinityJobOffer = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]), status = undefined as 'active' | 'visible' | 'expired' | 'all' | undefined, order = undefined as 'activeFirst' | undefined }) => {
  const haveMore = ref(true)
  const getMoreData = async () => {
    try {
      isLoading.value = true
      const searchRequest = jobOfferApi.getPaginated({ query: {search: search.value, limit: limit.value, page: page.value, ...(status && { status }), ...(order && { order })} })
      const searchResponse = await searchRequest.promise
      haveMore.value = searchResponse.count.hasNextPage
      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]
      return searchResponse
    }
    catch (err) {
      console.error('useInfinityJobOffer', err)
    }
    finally {
      isLoading.value = false
    }
  }
  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
  }
}
